import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NombresFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NOMBRES' htmlFor='select-nombres' md={2} />
      <Col md={10}>
        <Field name='nombres'>
          {({ field }) => (
            <Form.InputText
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-nombres'
              placeholder='Ingresar nombres ...'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NombresFormGroup)
